/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import './bootstrap';
import '@wwdev/functions/index.js';
import './wwdev/forms/index';

// import Zipcode from '@wwdev/zipcode';
import './wwdev/lazysizes/index.js';
//import './wwdev/webshop/index.js';


import './extern/plugins.js';
import './extern/bootstrap.min.js';
import './extern/main.js';
import './extern/navigation.js';

import './local/default.js';
import '@vvg/forum/vue.js'

// import '@wwdev/bootstrap/index.js';
import '@fancyapps/fancybox';
// import wwdev from '@wwdev/functions'; // to load all functions; all functions are bound to wwdev. example: wwdev.getResponsiveWidth()
// import getResponsiveWidth from '@wwdev/functions/getResponsiveWidth'; // to load single function. preffered to reduce code size
// Zipcode.init();

